<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SEED_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.adminContext.seed;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(seed) {
      // console.log("update seed", seed, this.editableEntry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(seed, this.editableEntry.validations))
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_SEED_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(seed, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateSeed.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_SEED_QUERY = gql `
  query ($id: ID!) { 
    adminContext {
      seed (id: $id) {
        id        
        barcode        
        brandId
        brand {
          id
          name
        }        
        unitId
        unit {
          id
          name
        }
        varietyId
        variety{
          id
          name
        }
        packagingIds
        validations
      }
    }
    globalContext {
      allUnits {
        id
        name
      }
      allVarieties {
        id
        name
        title
      }
    } 
    accountGlobalSharedContext {
      allBrandsOfItems {
        id
        name
      }
      allPackagingsOfItem(itemId: $id) {
        id
        name
        size
        text
      }
      allGroups{
        id
        name
      }
    }
  }
`;

const UPDATE_SEED_MUTATION = gql `
  mutation($input: SeedUpdateInputObject!) {
    updateSeed(input: $input) {
      item {
        id
        name        
        barcode              
        brandId
        brand {
          name
        }
        unitId
        unit {
          name
        }
        packagingIds
      }
      errors
    }
  }
`;

</script>

<style scoped></style>